import history from 'providers/history';
import tokenService from 'services/tokenService';
import NotificationService from 'services/notificationService';
import store from 'redux/store';
import { authActions } from 'redux/auth';

function onDeviceReady() {
  window.addEventListener('keyboardWillShow', () => document.body.classList.add('has-keyboard-open'), { passive: true });
  window.addEventListener('keyboardWillHide', () => document.body.classList.remove('has-keyboard-open'), { passive: true });

  // Enable universal links
  if (window.universalLinks) {
    window.universalLinks.subscribe(null, eventData => {

      if (eventData.params?.side === 'directory') {
        history.push('/directory');
        return;
      }

      if (eventData.params?.side === 'contacts') {
        history.push('/contacts');
        return;
      }

      if (eventData?.path || Object.keys(eventData.params).length > 0) {
        history.push({
          pathname: eventData.path,
          search: new URLSearchParams(eventData.params).toString(),
        });
      }
    });
  }

  // Set up fcm_token and apns_token fetching
  // Set up notification actions
  if (window.FirebasePlugin) {
    const onFcmToken = async (token) => {
      if (!token) {
        return;
      }
      await tokenService.setFcmToken(token);
      store.dispatch(authActions.deviceTokenReceived());
    };

    const onApnsToken = async (token) => {
      if (!token) {
        return;
      }
      await tokenService.setApnsToken(token);
      store.dispatch(authActions.deviceTokenReceived());
    };

    window.FirebasePlugin.getToken(onFcmToken);
    window.FirebasePlugin.onTokenRefresh(onFcmToken);
    window.FirebasePlugin.getAPNSToken(onApnsToken);
    window.FirebasePlugin.onApnsTokenReceived(onApnsToken);
    window.FirebasePlugin.onMessageReceived(({ tap, ...data }) => {
      if (tap && tap === 'background') {
        NotificationService.onNotificationClick({ data });
        // TODO: No backend support to mark only one comment read
        // readNotifications([data.notificationId]);
      } else {
        // App in foreground. Received a notification...
      }
    });
  }
}

const init = () => {
  document.addEventListener('deviceready', onDeviceReady, { passive: true });
};

export default init;
